<template>
  <div class="container">
    <div class="module_section1">
      <div class="banner_cont">
        <div class="title">虚拟电厂 VPP Cloud（Virtual Power Plant）</div>
        <div class="subtitle1">以储能为核心，基于电池AI和能源AI，可实现分钟级、秒级响应的直控型虚拟电厂</div>
      </div>
    </div>
    <div class="module_section2 module">
      <!-- <img class="kIcon" src="https://oss.duodians.com/lambda/office_web/solution/k_icon.png" alt=""> -->
      <div class="overview_cont">
        <div class="overview_left">
          <p class="title">虚拟电厂 VPP Cloud</p>
          <p class="text">基于用户需求、负荷预测、发电预测和安全调度模型，利用IoT和大数据平台构架，协手能源电力公司打造虚拟电厂运营管理平台，通过VPP参与电力现货市场交易，实现分布式电源、储能微网、储能系统、可控负荷等分布式能源的聚合和协调控制；</p>
          <p class="text">作为一个特殊电厂参与电力市场和电网运行，接受电网调度指令，参与需求侧响应，提供电网辅助服务，实现“源-网-荷-储”电力平衡、储能管理、策略运营和优化协调运行等功能，迎接电力间歇性难题，节约场站管理成本，提高场站收益，实现碳中和。</p>
        </div>
        <div class="overview_right">
          <img src="https://oss.duodians.com/lambda/office_web/virtualPower/section_right.png" alt="">
        </div>
      </div>
    </div>
    <div class="module_section3">
      <p class="title_com">产品优势</p>
      <div class="advantage_cont module">
        <div class="item" v-for="(el, ind) in advantageList" :key="ind">
          <img class="icon" :src="el.icon" alt="">
          <p class="title" v-html="el.title"></p>
          <p class="text">{{ el.text }}</p>
        </div>
      </div>
    </div>
    <div class="module_section4">
      <p class="title_com">需求响应业务</p>
      <div class="subTile_com">主站侧完成响应能力的汇总和响应需求的分解下发；场站侧经过自身的响应能力评估，整合后，上报到主站侧；同时接收主站下发的响应需求，并按照执行分发策略，分发给具体的响应单元</div>
      <div class="business_cont module">
        <div class="item" v-for="(el, ind) in businessList" :key="ind">
          <img class="icon" :src="el.icon" alt="">
          <div class="right">
            <p class="title">{{ el.title }}</p>
            <p class="text">{{ el.text }}</p>
          </div>
        </div>
      </div>
      <div class="framework_cont module">
        <img src="https://oss.duodians.com/lambda/office_web/virtualPower/section4_img.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      advantageList: [{
        icon: 'https://oss.duodians.com/lambda/office_web/virtualPower/advantage01.png',
        title: '需求侧响应',
        text: '响应预案管理、响应资源管理、响应能力分析、需求响应申报、需求响应执行、响应效果评价、响应补贴管理'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/virtualPower/advantage02.png',
        title: '多负荷管理场景',
        text: '灵活适用于光伏、储能、充电桩、工商业、光储充一体等多种场景；组织虚拟电厂参与电力市场化交易业务'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/virtualPower/advantage03.png',
        title: '多业务响应能力',
        text: '聚合各类电力用户响应资源，利用技术化手段充分发挥资源特性，为电网提供多种类调节响应服务'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/virtualPower/advantage04.png',
        title: '智能AI算法',
        text: '自学习的虚拟电厂响应与分配策略、微网控制和协同调度算法模型，结合Energy AI充放电成本评估模型，适配实际环境'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/virtualPower/advantage05.png',
        title: '全生命周期',
        text: '通过云端集控，保障微电网能源运行管理、交易、辅助服务、碳运营等储能资产安全可靠及长效寿命'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/virtualPower/advantage06.png',
        title: 'API开放平台',
        text: '云端架构，提供标准API接口，实现与三方生态伙伴系统的数据共享'
      }],
      businessList: [{
        icon: 'https://oss.duodians.com/lambda/office_web/virtualPower/business_icon01.png',
        title: '响应预案管理',
        text: '将不同响应形式的功能范围向微网场站侧延伸，在响应接入、响应过程中更加方便快捷'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/virtualPower/business_icon02.png',
        title: '响应资源管理',
        text: '通过日内滚动优化、实时校正两种方法进行多时间尺度协调，保障虚拟电厂调度与控制鲁棒性'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/virtualPower/business_icon03.png',
        title: '响应能力分析',
        text: '基于超短期电力负荷及发电功率预测模型的响应能力分析，实现平衡有功功率偏差，满足有功功率控制需求、优化响应调度'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/virtualPower/business_icon04.png',
        title: '响应修正能力',
        text: '根据短期负荷预测误差带，在制定日前调度计划前通知需求响应资源的参与量和预留量进行约束，为日内调整计划、修正日前计划偏差做准备'
      }],
    };
  },
  components: {},

  computed: {},

  methods: {
  }
};
</script>
<style lang='less' scoped>
.container{
  position: relative;
  top:-80px;
  z-index: 1;
  .module{
    width:1300px;
    margin: 0 auto;
  }
  .title_com{
    font-size: 46px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    text-align: center;
    color: #000000;
    line-height: 66px;
    padding: 100px 0 12px;
  }
  .subTile_com{
    margin: 0 auto 0;
    width: 840px;
    height: 62px;
    opacity: 0.6;
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #000000;
    line-height: 30px;
  }
  .module_section1{
    height: 630px;
    background: url('https://oss.duodians.com/lambda/office_web/virtualPower/section1_bg.jpg');
    background-size: 100% 100%;
    .banner_cont{
      padding-top: 162px;
      .title{
        font-size: 48px;
        font-family: Source Han Sans CN, Source Han Sans CN-Bold;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        line-height: 48px;
      }
      .subtitle1{
        margin: 50px auto 0;
        width: 932px;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 30px;
      }
      .btn{
        margin: 50px auto 0;
        width: 200px;
        height: 50px;
        border: 2px solid;
        border-radius: 28px;
        border-image: linear-gradient(270deg, #4add69 18%, #4cddbd 58%, #3cecf0 43%, #12ee90 99%) 2 2;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #4cddbd;
      }
    }
  }
  .module_section2{
    margin-top: -140px;
    height: 540px;
    border-radius: 30px;
    background: url('https://oss.duodians.com/lambda/office_web/solution/section2_bg.png') #f6fafd ;
    background-size: 100% 100%;
    position: relative;
    .kIcon{
      position: absolute;
      width: 131px;
      top: 74px;
      left: 120px;
    }
    .overview_cont{
      position: absolute;
      z-index: 2;
      width:980px;
      margin: 40px 0 0 170px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .overview_left{
        width:440px;
        .title{
          font-size: 36px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: left;
          color: #000000;
          line-height: 34px;
        }
        .subTitle{
          font-size: 26px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #000000;
          line-height: 34px;
          margin-top: 14px;
        }
        .text{
          margin-top: 33px;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: justify;
          color: #000000;
          line-height: 28px;
          letter-spacing: 0.08px;
        }
      }
      .overview_right{
        img{
          width:476px;
          height: 460px;
        }
      }
    }
  }
  .module_section3{
    margin-top: 100px;
    height: 960px;
    background: #f6fafd;
    .advantage_cont{
      margin-top: 60px;
      display: flex;
      flex-wrap: wrap;
      .item{
        width: 410px;
        height: 320px;
        background: #ffffff;
        border-radius: 8px;
        margin: 0 33px 34px 0;
        padding: 40px 30px 0;
        text-align: center;
        .icon{
          width: 100px;
          height: 100px;
          margin-bottom: 25px;
        }
        .title{
          font-size: 26px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          text-align: center;
          color: #303132;
          line-height: 32px;
          margin-bottom: 5px;
        }
        .text{
          margin-top: 18px;
          font-size: 18px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          color: #303132;
          line-height: 24px;
        }
      }
      .item:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  .module_section4{
    height: 1432px;
    margin-bottom: -80px;
    .business_cont{
      padding-top: 60px;
      display: flex;
      flex-wrap: wrap;
      .item{
        width: 634px;
        height: 190px;
        background: #f6fafd;
        border-radius: 8px;
        margin: 0 32px 34px 0;
        padding: 0px 40px 0;
        display: flex;
        align-items: center;
        .icon{
          width: 100px;
          height: 100px;
        }
        .right{
          width: 410px;
          margin-left: 40px;
          .title{
            font-size: 26px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            text-align: left;
            color: #303132;
            line-height: 32px;
            margin-bottom: 5px;
          }
          .text{
            opacity: 0.8;
            margin-top: 18px;
            font-size: 18px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: left;
            color: #303132;
            line-height: 24px;
          }
        }
      }
      .item:nth-child(2n) {
        margin-right: 0;
      }
    }
    .framework_cont{
      img{
        margin-top: 26px;
        width:100%;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/virtualPower/virtualPower.vue